import type { ReactNode } from 'react';
import { APP_NAME } from '@/components/PageHeader';
import { ChartBackdrop } from '@/layout/ChartBackdrop';
import { BrandMark } from '@/layout/AppHeader';
import { toWareki, todayISO, weekdayJa } from '@/lib/wareki';

/**
 * ログイン系画面の共通枠（左：海図のビジュアル、右：フォーム）。
 * ログイン・2段階認証の確認コード入力・認証アプリ登録・利用不可の案内で使う。
 */
export function LoginShell({ children, wide }: { children: ReactNode; wide?: boolean }) {
  const today = todayISO();
  return (
    <div className="bs-login">
      <section className="bs-login__visual" aria-hidden>
        <ChartBackdrop />
        <div className="bs-login__visual-inner">
          <div className="bs-login__mark">
            <BrandMark size={44} />
          </div>
          <p className="bs-login__kicker">OKINAWA FISHERIES PROMOTION FUND</p>
          <p className="bs-login__headline">
            外国漁船操業等
            <br />
            調査・監視事業システム
          </p>
          <p className="bs-login__lead">
            沖縄周辺海域における外国漁船の操業状況を、
            <br />
            漁業者・漁協・振興基金・行政が一つの海図で共有する。
          </p>
        </div>
        <dl className="bs-login__coords">
          <div>
            <dt>LAT</dt>
            <dd>26°12′N</dd>
          </div>
          <div>
            <dt>LON</dt>
            <dd>127°40′E</dd>
          </div>
          <div>
            <dt>DATE</dt>
            <dd>{today.replace(/-/g, '.')}</dd>
          </div>
        </dl>
      </section>

      <main className="bs-login__panel">
        <div className={wide ? 'bs-login__form-wrap bs-login__form-wrap--wide' : 'bs-login__form-wrap'}>
          <p className="bs-login__date">
            {toWareki(today)}（{weekdayJa(today)}）
          </p>
          {children}
        </div>
        <footer className="bs-login__footer">{APP_NAME}</footer>
      </main>
    </div>
  );
}
